import React, {ReactNode} from 'react';

interface Props {
    children?: ReactNode;
    className?: string;
}

const Row = ({
    children,
    className = '',
}: Props) => <div className={`row ${className}`}>{children}</div>;

export default Row;
